import { themeConfig, Theme } from "alurkerja-ui";

export const alurkerjaThemeConfig: Theme = {
  ...themeConfig,
  table_head_row: "text-neutral-800",
  table_head_col:
    "whitespace-nowrap py-3 px-3 capitalize relative cursor-pointer text-start text-neutral-800 min-w-44",
  table_body_col:
    "px-3 text-black text-xs py-2 sm:py-3 whitespace-nowrap w-min",
  table_head_col_active_sort: "!text-blue-600",
};
